import React from 'react';
import Abjad from '../Abjad.js'
import { MistakeHandler } from '../MistakeHandler.js'

const abjad = new Abjad()
const mistakeHandler = new MistakeHandler()

class ArabToLatinModule extends React.Component {
  state = {
    question: null,
    lesson: null,
    choices: [],
    counter: 0,
    correct: 0,
    wrong: 0,
    goal: 10
  }
  newQuestions() {
    const arr = abjad.getSet(this.props.lesson.set)
    const randomCorrectPos = Math.floor(Math.random() * Math.floor(arr.length))
    // If it's the same question as the last one
    if (!arr[randomCorrectPos].equals(this.state.question)) {
      this.setState({question: arr[randomCorrectPos], choices: arr})
    } else { // Fetch a new one
      this.newQuestions()
    }
  }

  componentDidMount() {
    this.setState({form: this.props.form, lesson: this.props.lesson})
    this.newQuestions()
  }

  answerCallback(answered) {
    if (abjad.compare(this.state.question, answered)) {
      this.setState({correct: this.state.correct + 1})
      this.setState({counter: this.state.counter + 1})
    } else {
      this.setState({wrong: this.state.wrong + 1})
      this.setState({counter: 0})
      mistakeHandler.addMistake(this.state.question)
    }
    this.newQuestions()
  }
  setDone() {
    this.setState({counter: 0})
    this.state.lesson.incrementForm()
  }
  render () {

    if (this.state.counter >= this.state.goal && this.state.lesson.allFormsDone()) {
      return (<div>
        <h5>Good job!</h5>
        <p>Let's go back to the menu and go for the next lesson. </p>
        <button className="ArticleButtonBox" onClick={this.props.practiceDone}>Alright</button>
        </div>)
    } else if (this.state.counter >= this.state.goal && !this.state.lesson.allFormsDone()) {
      return (<div>
        <p>Great!</p>
        <p>Let's continue practising.</p>
        <button className="ArticleButtonBox" onClick={this.setDone.bind(this)}>Next set</button>
        </div>)
    }
    if (this.state.question != null) {
      return (<div>
        <p>{this.state.counter}/{this.state.goal}</p>
        <h4>Select the Latin equivalent of this letter</h4>
        <div className="Question">{this.state.question.getForm(this.state.lesson.form)}</div>
      <InputPart answerCallback={this.answerCallback.bind(this)}  choices={this.state.choices}/>
      </div>)
    } else return null
  }
}

class InputPart extends React.Component {
  render () {
    return (
      <div><ul>
      {this.props.choices.map(item => {
        return (<InputButton answerCallback={this.props.answerCallback} item={item} key={item.id}/>)
      })}
      </ul></div>
    )
  }
}

class InputButton extends React.Component {
  answer() {
    this.props.answerCallback(this.props.item)
  }
  sound() {
    if (this.props.item.sound != null) {
      this.props.item.sound.play()
    }

  }
  render () {
    return (<div onMouseEnter={this.sound.bind(this)} className="QuestionBox" onClick={this.answer.bind(this)}>{this.props.item.latin}</div>)
  }
}

export default ArabToLatinModule
